import { SelfplusUsersApiFactory } from '../../api/default';
import { apiResponseAdHoc } from '../helpers';

const selfplusUsersApi = SelfplusUsersApiFactory();

interface SelfPlusAdmin {
  readonly id: number;
  readonly name: string;
  readonly slug: string;
  readonly avatar: {
    readonly url: string;
  } | null;
}

export async function getSelfPlusAdmins(): Promise<SelfPlusAdmin[]> {
  return selfplusUsersApi.selfplusUsersGet().then(r => apiResponseAdHoc(r.data));
}
